import { z } from 'zod'
import { Timestamp } from './common.js'
import { UserRole } from './user.js'

export const AdminUserStatus = z.enum(['active', 'deleting', 'deleted'])
export type AdminUserStatus = z.infer<typeof AdminUserStatus>

export const AdminUserLoginMethod = z.enum(['password', 'apple'])
export type AdminUserLoginMethod = z.infer<typeof AdminUserLoginMethod>

export const AdminUserBusinessStats = z.object({
  published_routes: z.number().int().nonnegative(),
  draft_routes: z.number().int().nonnegative(),
  pending_review_routes: z.number().int().nonnegative(),
  proposals: z.number().int().nonnegative(),
  photos: z.number().int().nonnegative(),
  favorites: z.number().int().nonnegative(),
  comments: z.number().int().nonnegative(),
})
export type AdminUserBusinessStats = z.infer<typeof AdminUserBusinessStats>

export const AdminUserListItem = z.object({
  id: z.string().uuid(),
  status: AdminUserStatus,
  username: z.string().optional(),
  display_name: z.string().optional(),
  avatar_url: z.string().optional(),
  role: UserRole.optional(),
  level: z.number().int().min(1).max(6).optional(),
  profile_completed: z.boolean().optional(),
  created_at: Timestamp.optional(),
  deletion_started_at: Timestamp.optional(),
  deleted_at: Timestamp.optional(),
  login_methods: z.array(AdminUserLoginMethod),
  stats: AdminUserBusinessStats.nullable(),
})
export type AdminUserListItem = z.infer<typeof AdminUserListItem>

export const AdminUserListSummary = z.object({
  active: z.number().int().nonnegative(),
  deleting: z.number().int().nonnegative(),
  deleted: z.number().int().nonnegative(),
})
export type AdminUserListSummary = z.infer<typeof AdminUserListSummary>

export const AdminUserListResponse = z.object({
  items: z.array(AdminUserListItem),
  page: z.number().int().positive(),
  page_size: z.number().int().positive(),
  total: z.number().int().nonnegative(),
  total_pages: z.number().int().nonnegative(),
  summary: AdminUserListSummary,
})
export type AdminUserListResponse = z.infer<typeof AdminUserListResponse>
